import ColumnChartWidget from './ColumnChartWidget';
import { LiveClassesTable } from './LiveClassesTable';
import BarChartWidget from './BarChartWidget';
import { ApiClient } from 'jsonapi-react';
import { useEffect, useRef, useState } from 'react';
import Loader from '@/app/components/loader';
import { EmptyState } from '@/components/custom/empty-state';
import toast from 'react-hot-toast';

export default function LiveClassesTab({ filters, currentFilters }) {
  const apiSso = process.env.REACT_APP_SSO_API_URL;
  const [barChartData, setBarChartData] = useState([]);
  const [columnChartData, setColumnChartData] = useState([]);
  const [loadingGraph, setLoadingGraph] = useState(false);

  const client = new ApiClient({
    url: `${apiSso}/api/v1`
  });

  const regionals = currentFilters.filter(item => item.type === 'regional').map(item => item.value);
  const institutionsWithInep = currentFilters.filter(item => item.type === 'institution' && item.value).map(item => item.value);
  const institutionsWithoutInep = currentFilters.filter(item => item.type === 'institution' && !item.value).map(item => item.name);
  const series = currentFilters.filter(item => item.type === 'serie').map(item => item.value);

  const getGraphData = async () => {
    if (loadingGraph) return;
    setLoadingGraph(true);
    let url = `/live_classroom_accesses/graphs?initial_date=${filters.values['start-date']}&final_date=${filters.values['end-date']}`;

    if (regionals.length > 0) {
      url += `&regional_code=${regionals.join(',')}`;
    }
    if (institutionsWithInep.length > 0) {
      url += `&institution_inep=${institutionsWithInep.join(',')}`;
    }

    if (institutionsWithoutInep.length > 0) {
      url += `&institution_name=${institutionsWithoutInep.join(',')}`;
    }
    if (series.length > 0) {
      url += `&source=${series.join(',')}`;
    }

    try {
      const { data } = await client.fetch(url);
      setBarChartData(data['access-by-component']);
      setColumnChartData(data['access-by-source']);
    } catch (error) {
      toast.error('Erro ao buscar os dados do gráfico.');
    }
    setLoadingGraph(false);
  };

  useEffect(() => {
    getGraphData();
  }, [filters.values, currentFilters]);

  const hasNoData = Object.keys(barChartData).length === 0 && Object.keys(columnChartData).length === 0;

  return (
    <>
      {loadingGraph && <Loader />}
      {hasNoData && !loadingGraph && (
        <EmptyState
          title="Nenhum dado encontrado"
          type="data"
          text="Tente ajustar os filtros para obter resultados."
        />
      )}
      {!loadingGraph && !hasNoData && (
        <div className="report-kpi-card-wrapper">
          <ColumnChartWidget data={columnChartData} />
          <BarChartWidget data={barChartData} />
          <LiveClassesTable
            regionals={regionals}
            institutionsWithInep={institutionsWithInep}
            institutionsWithoutInep={institutionsWithoutInep}
            series={series}
            filters={filters}
            currentFilters={currentFilters}
          />
        </div>
      )}
    </>
  );
}
